var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "accordion",
      class: {
        full: _vm.full,
        "no-border": _vm.noBorder,
        "not-permitted": !_vm.permitted,
      },
    },
    [
      _c(
        "el-collapse",
        {
          on: { change: _vm.onExpand },
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        [
          _c(
            "el-collapse-item",
            { key: _vm.id, attrs: { name: "1", disabled: !_vm.permitted } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  (_vm.full && _vm.dirButtonLeft) || _vm.level == "state"
                    ? _c(
                        "div",
                        {
                          staticClass: "accordion__title-right",
                          class: { "no-left-margin": _vm.noLeftMargin },
                        },
                        [
                          _vm.full && _vm.dirButton && _vm.permitted
                            ? _c("AccordionButton", {
                                attrs: {
                                  direction: _vm.isDown
                                    ? "prev-down"
                                    : "prev-up",
                                  icon: _vm.isDown
                                    ? "arrow-up--red"
                                    : "arrow-down--red",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.full && _vm.info
                            ? _c("Info", {
                                attrs: {
                                  text: "Last update " + _vm.fixDate,
                                  arrow: false,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.iso
                    ? _c("Country", {
                        attrs: {
                          iso: _vm.iso,
                          size: "smallpadded",
                          icon: _vm.flag,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("title", function () {
                    return [
                      _vm.full
                        ? _c("TitleBlock", {
                            attrs: {
                              text: _vm.title,
                              color: "white",
                              size: _vm.size,
                              link: _vm.seeAll,
                              padding: false,
                            },
                          })
                        : !_vm.full && !_vm.link
                        ? _c("TitleVx", {
                            attrs: { text: _vm.title, size: "small" },
                          })
                        : _c(
                            "nuxt-link",
                            {
                              staticClass: "title-link",
                              attrs: { to: _vm.link },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.title) +
                                  "\n        "
                              ),
                            ]
                          ),
                    ]
                  }),
                  _vm._v(" "),
                  !_vm.dirButtonLeft
                    ? _c(
                        "div",
                        { staticClass: "accordion__title-right" },
                        [
                          _vm.full && _vm.dirButton && _vm.permitted
                            ? _c("AccordionButton", {
                                attrs: {
                                  direction: _vm.isDown
                                    ? "prev-down"
                                    : "prev-up",
                                  icon: _vm.isDown
                                    ? "arrow-up--red"
                                    : "arrow-down--red",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tip
                            ? _c("Tip", {
                                staticClass: "tip-button-report",
                                attrs: { "tip-content": _vm.tipContent },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.full && _vm.info
                            ? _c("Info", {
                                attrs: {
                                  text: "Last update " + _vm.fixDate,
                                  arrow: false,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "inner-accordion" },
                [_vm._t("default")],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }